import script from "./BroadcastEditorModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BroadcastEditorModal.vue?vue&type=script&setup=true&lang=js"

import "./BroadcastEditorModal.vue?vue&type=style&index=0&id=7c80ffeb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c80ffeb"]])

export default __exports__